// angular
// 	.module("HeroPRO")
// 	.filter("monthName", monthName);

export default function monthName() {
    return function getMonthName(monthNumber) {
        const monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
        return monthNames[Number(monthNumber) - 1];
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/filters/monthName.filter.js